"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssigneeEditCell = void 0;
var assignee_edit_cell_component_1 = require("./assignee-edit-cell.component");
Object.defineProperty(exports, "AssigneeEditCell", { enumerable: true, get: function () { return assignee_edit_cell_component_1.AssigneeEditCell; } });
